import React, { useEffect, useRef, useState } from "react";
import AgentInfo from "./AgentInfo";
import Seperator from "../../Atoms/Seperator";
import AgentCapabilities from "./AgentCapabilities";
import VersionAndProvider from "./VersionAndProvider";
import AgentClassification from "./AgentClassification";
import { useAgent } from "../../../contexts/AgentsContext";
import {
  PUBLISHED_TXT,
  TOAST_CLASSES,
} from "../../../utils/constants";
import CustomButton from "../../Atoms/Buttons/CustomButton";
import ReasonForRejctionAgent from "./ReasonForRejectionAgent";
import usePermissions from "../../../hooks/userPermissions";

const AgentDetails = () => {
  const {
    selectedAgent,
    agentVersions,
    currentAgentVersion,
    isLoadingVersions,
    publishAgent,
    isApprovingRejecting,
    fetchAgentsSilently,
    showToastMessage,
    clearSelectedAgent,
    clearAgentVersions,
    clearCurrentAgentVersion,
    fetchAgentBFs,
    changeAgentDrawerState,
  } = useAgent();

  const { canAgentPublish, canAgentUnpublish } = usePermissions();

  const reasonBoxRef = useRef(null);

  const [activeAgentData, setActiveAgentData] = useState(selectedAgent);
  const [enableReasonBox, setEnableReasonBox] = useState(false);

  // Update active solution data when selected solution or versions change
  useEffect(() => {
    if (currentAgentVersion) {
      setActiveAgentData(
        agentVersions?.find(
          (version) => version?.version === currentAgentVersion
        )
      );
    } else {
      setActiveAgentData(selectedAgent);
    }
  }, [currentAgentVersion, agentVersions, selectedAgent]);

  const clearAgentDrawerData = async () => {
    clearSelectedAgent();
    clearAgentVersions();
    clearCurrentAgentVersion();

    fetchAgentsSilently();
    fetchAgentBFs();

    changeAgentDrawerState(false);
  };

  const handlePublish = async (e, agentId, approvalStatus) => {
    e.preventDefault();
    e.stopPropagation();
    if (!agentId) {
      showToastMessage("Agent ID is not available.", TOAST_CLASSES?.ERROR);
      return;
    }
    await publishAgent(agentId, approvalStatus);
  };

  useEffect(() => {
    if (enableReasonBox && reasonBoxRef?.current) {
      setTimeout(() => {
        reasonBoxRef?.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [enableReasonBox]);

  return (
    <div>
      <AgentInfo activeAgentData={activeAgentData} />
      <Seperator
        styles={{
          border: 0,
          borderTop: "1px solid var(--db-secondary-gray-four)",
          strokeWidth: "O.5px",
          margin: "0",
        }}
      />
      {/* <AgentCapabilities activeAgentData={activeAgentData} /> */}
      <Seperator
        styles={{
          border: 0,
          borderTop: "1px solid var(--db-secondary-gray-four)",
          strokeWidth: "O.5px",
          margin: "0",
        }}
      />
      <VersionAndProvider activeAgentData={activeAgentData} />
      <Seperator
        styles={{
          border: 0,
          borderTop: "1px solid var(--db-secondary-gray-four)",
          strokeWidth: "O.5px",
          margin: "0",
        }}
      />
      <AgentClassification activeAgentData={activeAgentData} />

      {/* Publish Button */}
      {canAgentPublish && <div className="d-flex justify-content-end mt-3">
        <CustomButton
          label={`${selectedAgent?.approval_status?.toLowerCase() === PUBLISHED_TXT?.toLowerCase()
            ? "Unpublish"
            : "Publish"
            }`}
          onClickFn={async (e) => {
            if (
              selectedAgent?.approval_status?.toLowerCase() !== PUBLISHED_TXT?.toLowerCase()
            ) {
              await handlePublish(e, selectedAgent?.agent_id, PUBLISHED_TXT);

              await clearAgentDrawerData();
            } else {
              setEnableReasonBox(true);
            }
          }}
          clsNames={"mas-btn-med mas-secondary-btn-3"}
          disabled={
            isApprovingRejecting ||
            isLoadingVersions ||
            enableReasonBox ||
            currentAgentVersion !== agentVersions?.length
          }
        />
      </div>}

      {/* Reason for Rejection for unpublished */}
      {
        enableReasonBox && (
          <div ref={reasonBoxRef}>
            <ReasonForRejctionAgent
              setEnableReasonBox={setEnableReasonBox}
              agentId={selectedAgent?.agent_id}
              clearAgentDrawerData={clearAgentDrawerData}
            />
          </div>
        )
      }
    </div >
  );
};

export default AgentDetails;
